export default {
  updateViewsOnHeader(context, data) {
    context.commmit('updateView', data)
  }
}
